import type { PropsWithChildren } from 'react'

import { MessageMediaQueryProvider } from '@/modules/message/query/message-media-query-context.tsx'
import { DefaultMessageMediaProvider } from '@/modules/message/service/message-fetch-context.tsx'

export const RebillMessagesModule = ({ children }: PropsWithChildren) => {
  return (
    <DefaultMessageMediaProvider>
      <MessageMediaQueryProvider>{children}</MessageMediaQueryProvider>
    </DefaultMessageMediaProvider>
  )
}
